import { useLiveQuery } from 'dexie-react-hooks'
import { CalendarClock } from 'lucide-react'
import { Link } from 'react-router-dom'
import { nomPlanningLocal, useRole } from '../lib/compte'
import { listerChantiers } from '../lib/chantiers'
import { aujourdhuiLocal, libelleJour, rappelDemain } from '../lib/planning'
import { getBase } from '../outbox/base'

/**
 * Ce qui est prévu au prochain jour travaillé, en tête de l'accueil et de la liste des chantiers. Un ouvrier ne voit
 * que ses tâches. C'est une lecture du planning à l'ouverture de l'app : sans serveur d'envoi, il n'y a pas de
 * notification poussée quand l'app est fermée.
 */
export function RappelDemain() {
  const base = getBase()
  const ouvrier = useRole() === 'ouvrier'
  const moi = nomPlanningLocal()
  const chantiers = useLiveQuery(() => listerChantiers(base), [], [])
  const { jour, tuiles } = rappelDemain(chantiers, aujourdhuiLocal(), ouvrier ? (moi ?? '\u0000') : undefined)
  if (tuiles.length === 0) return null
  return (
    <section aria-label="Rappel du prochain jour" className="flex flex-col gap-1 rounded-2xl border-2 border-nuit bg-slate-100 p-3 text-sm">
      <h3 className="flex items-center gap-2 font-semibold">
        <CalendarClock aria-hidden className="size-4" /> Prévu {libelleJour(jour)}
      </h3>
      <ul className="flex flex-col gap-0.5">
        {tuiles.map((t) => (
          <li key={t.tache.id}>
            <Link to={`/chantiers/${t.chantier.id}`} className="underline">
              {t.tache.libelle}
            </Link>{' '}
            · {t.chantier.nom}
            {t.tache.creneau === 'matin' && ' · matin'}
            {t.tache.creneau === 'apres_midi' && ' · après-midi'}
            {t.tache.ouvriers.length > 0 && !ouvrier && ` · ${t.tache.ouvriers.join(', ')}`}
          </li>
        ))}
      </ul>
    </section>
  )
}
